import {Injectable} from '@angular/core';
import {HttpInterceptor, HttpRequest, HttpHandler, HttpEvent} from '@angular/common/http';
import {Observable, timeout} from 'rxjs';
import {finalize} from 'rxjs/operators';
import {LoadingService} from '../service/loading.service';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  constructor(private loadingService: LoadingService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.url.includes('?loading=true')
      || (!request.url.includes('oauth2/token') && !request.url.includes('datacenters/page'))
      || request.url.includes("withErrors=true")) {
      this.loadingService.setLoading(true, request.url);
      return next.handle(request).pipe(
        timeout(600000),
        finalize(() => {
          this.loadingService.setLoading(false, request.url);
        })
      );
    } else {
      return next.handle(request).pipe(
        timeout(600000));
    }
  }
}
